import { useToast } from '@chakra-ui/react'

export default function SToast() {
  const toast = useToast()

  const errorToast = () => {
    toast({
      title: '에러가 발생했습니다. 다시 시도해주세요.',
      status: 'error',
      position: 'top',
      isClosable: true,
      duration:2000,
    });
  };

  const successToast = (text:string) => {
    toast({
      title: text,
      status: 'success',
      position: 'top',
      isClosable: true,
      duration:2000,
    });
  };

  const warningToast = (text: string) => {
    toast({
      title: text,
      status: 'warning',
      position: 'top',
      isClosable: true,
      duration:2000,
    });
  };

  const customErrorToast = (text: string) => {
    toast({
      title: text,
      status: 'error',
      position: 'top',
      isClosable: true,
      duration:2000,
    });
  };

    return { errorToast, successToast, warningToast, customErrorToast }
}
